import { render, staticRenderFns } from "./PayU.vue?vue&type=template&id=28d68ac5&scoped=true&"
import script from "./PayU.vue?vue&type=script&lang=js&"
export * from "./PayU.vue?vue&type=script&lang=js&"
import style0 from "./PayU.vue?vue&type=style&index=0&id=28d68ac5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28d68ac5",
  null
  
)

export default component.exports